export var contentWrapper = 'flex flex-row items-center px-4 py-4 sm:px-6 justify-between';
export var menuItemIconContainer = 'flex-shrink-0 h-12  w-12 rounded-full flex justify-center items-center ';
export var menuItemIconContainerDefault = 'bg-primary text-white';
export var menuItemIcon = 'flex-shrink-0 h-6 w-6 ';
export var menuTitle = 'text-sm font-medium text-primary truncate';
export var menuSubTitle = 'flex pl-0.5 items-center text-sm text-textLight';
export var menuChevron = 'h-6 w-6 text-primary';
export var menulistItemContainer = 'bg-uiBg rounded-10 hover:bg-uiLight cursor-pointer';
export var menuItemIconContainerNoAction = 'bg-uiBg rounded-10';
export var menuItemIconContainerCoachCirclesNoAction = 'bg-successBg rounded-10';
export var getColourByAlertSeverity = function (type) {
    switch (type) {
        case 'error':
            return 'errorMain';
        case 'warning':
            return 'alertMain';
        case 'success':
            return 'successMain';
        case 'none':
        default:
            return 'textLight';
    }
};
export var getShapeClassByAlertSeverity = function (type) {
    switch (type) {
        case 'error':
            return 'h-2.5 w-2.5 bg-errorMain';
        case 'warning':
            return 'h-0 w-0 border-opacity-0 border-t-0 border-l-5 border-l-transparent border-r-5 border-r-transparent border-b-10 border-b-alertMain shadow-none';
        case 'success':
            return 'h-2.5 w-2.5 rounded-full bg-successMain';
        default:
            return 'h-2.5 w-2.5 rounded-full bg-successMain';
    }
};
//# sourceMappingURL=user-alert-list-item.styles.js.map